import React from "react";

// An overlay that blocks the chat component below while the event diff is open
export const EventCardOverlay = () => {
  return <div className="cw-inset-0 cw-absolute cw-z-10 cw-bg-neutral cw-opacity-90" />;
};
